import { routeFrontOfficeCommonUser } from '@/lib/routes/front/common/routeFrontOfficeCommonUser'
import { routeFrontOfficeContracts } from '@/lib/routes/front/common/routeFrontOfficeContracts'
import { routeFrontOfficeInvoices } from '@/lib/routes/front/common/routeFrontOfficeInvoices'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

export const getFrontOfficeInsightHoldOwner = [
  ...routeFrontOfficeContracts,
  ...routeFrontOfficeInvoices,
  ...routeFrontOfficeCommonUser,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDINSIGHT],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_HOLD_OWNER_INSIGHT],
}))
